"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trade_token_lib_1 = require("trade_token_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const types_1 = require("./types");
const operators_1 = require("rxjs/operators");
const transform_1 = require("./transform");
/**
 * Circle出入金相关API
 */
class CircleDWAPI {
    constructor(apiKey) {
        this.apiKey = apiKey;
    }
    getRecords(tx_type) {
        const url = `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/records/`;
        return trade_token_lib_1.acquireKeyResolver()
            .requestSigner.getSignRequestV2("GET", `${url}?tx_type=${tx_type}`, JSON.stringify({ tx_type: types_1.DWSide.DEPOSIT }))
            .pipe(operators_1.map((response) => {
            var _a;
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.records)) {
                return [];
            }
            return response.data.records.map(transform_1.toWireHistoryInfo);
            // return response.data.records.map(toWireHistoryInfo).filter((item) => {
            //     if (filterProcessingRecord && item.txType === DWSide.DEPOSIT && item.txStatus !== DepositStatus.CONFIRMED && item.txStatus !== DepositStatus.ABNORMAL) {
            //         return false;
            //     }
            //     return true;
            // });
        }));
    }
    getBanks() {
        const url = `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/banks/`;
        return trade_token_lib_1.acquireKeyResolver()
            .requestSigner.getSignRequestV2("GET", url, "")
            .pipe(operators_1.map((response) => {
            var _a;
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.banks)) {
                return [];
            }
            return response.data.banks.map(transform_1.toBankCardInfo);
        }));
    }
    deletePayout(txId) {
        const url = `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/payout/${txId}/`;
        return trade_token_lib_1.acquireKeyResolver()
            .requestSigner.getSignRequestV2("DELETE", url, "")
            .pipe(operators_1.map((response) => {
            return response === null || response === void 0 ? void 0 : response.data;
        }));
    }
    unbindBankCard(bankId) {
        const url = `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/banks/${bankId}/`;
        return trade_token_lib_1.acquireKeyResolver().requestSigner.getSignRequestV2("DELETE", url, "");
    }
    updateBankStatus(bankId, status) {
        return trade_token_lib_1.acquireKeyResolver().requestSigner.getSignRequestV2("POST", `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/bank_status/`, JSON.stringify({
            bank_id: bankId,
            bank_status: status,
        }));
    }
    addBankCard(addBankCardParams) {
        return trade_token_lib_1.acquireKeyResolver().requestSigner.getSignRequestV2("POST", `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/banks/`, JSON.stringify(addBankCardParams));
    }
    addPayout(params) {
        const url = `${trade_utils_lib_1.getTradeDependencyInstance().getRunTimeHost().walletApiHost}/wire/payout/`;
        return trade_utils_lib_1.NetworkUtils.postWithAccessAndSpotAuth({
            url,
            data: {
                bank_id: params.bankId,
                amount: params.amount,
                sms_code: params.sms_code,
                google_code: params.google_code,
                email_code: params.email_code,
            },
        });
    }
}
exports.default = CircleDWAPI;
//# sourceMappingURL=CircleDWAPI.js.map